import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, Eye } from "lucide-react";
import { api } from "../../lib/api";

export const readTime = (p) => `${p.reading_minutes || 1} min read`;

export const PopularThisWeek = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/public/posts/popular?days=7&limit=5").then(({ data }) => setPosts(data.posts)).catch(() => {}); }, []);
  if (posts.length < 2) return null;
  return (
    <section className="mb-12 rounded-3xl border border-[#D4AF37]/25 bg-[#0F1015] p-5 sm:p-7" data-testid="popular-week">
      <p className="mb-5 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]"><Flame size={15} /> Most read this week</p>
      <ol className="-mx-1 flex snap-x gap-4 overflow-x-auto px-1 pb-1 lg:grid lg:grid-cols-5 lg:overflow-visible">
        {posts.map((p, i) => (
          <li key={p.id} className="min-w-[240px] snap-start lg:min-w-0">
            <Link to={`/blog/${p.slug}`} className="group flex h-full gap-3 rounded-2xl p-2 transition-colors hover:bg-white/[0.03]" data-testid={`popular-item-${i + 1}`}>
              <span className="font-serif text-4xl font-bold leading-none text-[#D4AF37]/40 transition-colors group-hover:text-[#D4AF37]">{i + 1}</span>
              <span className="min-w-0">
                <span className="line-clamp-2 text-sm font-semibold leading-snug text-white group-hover:text-[#F3D77A]">{p.title}</span>
                <span className="mt-1.5 flex items-center gap-2 text-[11px] text-zinc-500">
                  <span className="inline-flex items-center gap-1"><Eye size={11} /> {p.views}</span>· {readTime(p)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
};
